import React, { useState,useEffect } from "react";
import { Button, Card, Container, Row, Col, InputGroup, FormControl, Form, Image } from "react-bootstrap";
import { Avatar } from "antd";
import ReactCodeInput from "react-code-input";
import { useNavigate } from "react-router-dom";
import { css } from "@emotion/react";
import { useSpring, animated } from 'react-spring'
import { apiUrl } from "../commons/inFormTypes";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Loaders from '../components/Loaders';
import station from '../assets/img/station.png'
// import Logo4x from '../assets/img/Logo4x.png';
import recycling from '../assets/img/recycle10.png';

const props = {
  className: ReactCodeInput,
  inputStyle: {
    fontFamily: 'Yekan Bakh Fa 05 Medium',
    borderRadius: '6px',
    border: '1px solid lightgrey',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px 0px',
    margin: '3px',
    paddingLeft: '8px',
    width: '50px',
    height: '50px',
    fontSize: '32px',
    boxSizing: 'border-box',
    color: 'black',
    backgroundColor: 'white',
  }
}


function Login() {
  const [errorMobile, setErrorMobile] = useState("");
  const [mobile, setMobile] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [codeError, setcodeError] = useState("");
  const [snip, setSnip] = useState(false);
  const [formIsValid, setFormIsValid] = useState("1");
  const [rightMenuVisible, setRightMenuVisible] = useState(false);
  const [rightRegVisible, setRegMenuVisible] = useState(false);
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  
  useEffect(() => {
    const userToken = localStorage.getItem("user_token");    
    if(userToken !== null) {    
      navigate("/admin/dashboard");
    } else {
      navigate("/");
    }
  }
  ,[]) 

  const submitAnimation = useSpring({
    opacity: rightMenuVisible ? 0 : 1,
    transform: rightMenuVisible ? `translateX(100%)` : `translateX(0)`,
  });

  const loginAnimation = useSpring({
    opacity: rightMenuVisible ? 1 : 0,
    transform: rightMenuVisible ? `translateX(0)` : `translateX(100%)`,
  });

  // const registerAnimation = useSpring({
  //   opacity: rightRegVisible ? 1 : 0,
  //   transform: rightRegVisible ? `translateX(0)` : `translateX(100%)`,
  // });



  const submitHandler = (e) => {

    e.preventDefault();
    if (mobile.length < 10 || mobile === "" || mobile.length > 10) {
      setErrorMobile("لطفا شماره موبایل صحیح را وارد کنید");
      return false;
    } else {

      const axios = require("axios");
      setSnip(true);
      var mb = 0 + mobile
      axios.post(apiUrl + "Login_Station", { 
        mobile: mb,
        type:"st",      
      })
        .then((res) => {
          console.log(res.data.result)
          console.log(res.data.data)
          setSnip(false);
          if (res.data.result === "true") {
            setToken(res.data.data)
            setRightMenuVisible(!rightMenuVisible)
            setFormIsValid("2");
          }else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          setSnip(false);
          if (error.response) {
            console.log("data", error.response.data);
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };


  const inputHandle = pinCode => {
    setPinCode(pinCode);
  };

  const loginHandler = (e) => {

    e.preventDefault();
    if (pinCode === "") {
      setcodeError("لطفا کد صحیح را وارد کنید");
      return false;
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "CheckCode_Station", {
          Code: pinCode,
          TokenId: token,
        })

        .then((res) => {
          console.log(res.data.message)
          setSnip(false);
          if (res.data.result === "true") {
            console.log(res.data.result)
            localStorage.setItem("user_namefamily", res.data.data.Name);
            localStorage.setItem("user_token", res.data.data.TokenId);
            navigate("/admin/dashboard");
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          setSnip(false);
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }

  const keyPress = (e) => {
    if(e.keyCode === 13){
      submitHandler(e)
    }
 }

  return (
    <div>
      <div className="rgc-style loginStyle">
        <section className="">
          <Container className="">
            <Row className="d-flex justify-content-center align-items-center">
              <Col xs={12} md={8} lg={6} xl={5} className="rgc-login-style">

                <Card className="rgc-login-card shadow-2-strong">
                  <Card.Body className="text-center">
                    <div className="rgc-login-header mb-3">
                      {/* <Avatar
                        className="fa fa-user-circle rgc-avatar-log"
                        size="large"
                        src=""
                      /> */}
                      <Image src={recycling} alt="logo" className="rgc-logo-login" />
                      <div className="rgc-login-title mb-3">
                      <p>سامانه یکپارچه پسماند شهرداری آمل </p>
                        <h2>زیستماند</h2>
                      </div>
                    </div>

                    <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                      <animated.div style={submitAnimation}>
                        <InputGroup className="mb-1 rgc-input">
                          <InputGroup.Text id="basic-addon1" className="rgc-code">+98</InputGroup.Text>
                          <FormControl
                            className="rgc-code"
                            placeholder="912 *** ***"
                            aria-label="phoneNumber"
                            aria-describedby="basic-addon1"
                            type="number"
                            value={mobile}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onChange={(event) =>
                              setMobile(event.target.value)
                            }
                            onKeyDown={(event) => keyPress(event)}   
                          />
                        </InputGroup>
                        <small id="userHelp" className="text-danger form-text">
                          {errorMobile}
                        </small>
                        <br />
                      </animated.div>

                      <Button
                        type="button"
                        className="btn-fill m-1 rgc-btn"
                        onClick={submitHandler}
                        variant="btn"
                      >
                        <Loaders loads={snip} />
                        <span> مرحله بعد </span>
                      </Button>
                    </div>

                    <div className={formIsValid === "2" ? "d-block" : "d-none"}>
                      <animated.div style={loginAnimation}>
                        <ReactCodeInput
                          {...props}
                          id="pinCode"
                          type="number"
                          fields={4}
                          value={pinCode}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={inputHandle}

                        />
                        <br />
                        <small id="userHelp" className="text-danger form-text">
                          {codeError}
                        </small>
                        <br />
                      </animated.div>
                      <Button
                        type="submit"
                        className="btn-fill my-4 rgc-btn"
                        onClick={loginHandler}
                        variant="btn"
                      >
                        <Loaders loads={snip} />
                        <span>ورود</span>
                      </Button>
                    </div>
                    <div className="rgc-info-main text-center">
                      <Image src={station} alt="station" />
                      <p>اپلیکیشن ایستگاه</p>
                    </div>


                  </Card.Body>
                </Card>


              </Col>
            </Row>
          </Container>
          <div className="rgc-toast">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="rgc-toast"
        />
      </div>
        </section>
      </div>
    </div>
  );
}
export default Login;